<template>
  <div id="modalClient" class="modal fade" tabindex="-1">
    <div class="modal-dialog modal-lg">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">
            {{ client.typePerson === '1' ? 'Dados da Empresa' : 'Meus Dados' }}
          </h5>
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            title="Fechar"
            @click="$emit('closeModal', false)"
          />
        </div>
        <form @submit.prevent="updateClient">
          <div class="modal-body">
            <div class="row g-3">
              <div v-if="client.typePerson === '1'" class="col-sm-3">
                <label class="form-label">
                  CNPJ: <span class="text-danger">*</span>
                </label>
                <input
                  type="text"
                  class="form-control"
                  :class="{ 'is-invalid': v$.client.cnpjcpf.$errors.length }"
                  placeholder="00.000.000/0000-00"
                  v-model="v$.client.cnpjcpf.$model"
                  v-maska="'##.###.###/####-##'"
                  disabled
                />
                <span
                  v-if="v$.client.cnpjcpf.required.$invalid"
                  class="invalid-feedback"
                >
                  O campo é obrigatório
                </span>
                <span
                  v-if="v$.client.cnpjcpf.minLength.$invalid"
                  class="invalid-feedback"
                >
                  Formato de CNPJ inválido <br />
                  Ex: 00.000.000/0000-00
                </span>
              </div>
              <div v-if="client.typePerson === '1'" class="col-sm-5">
                <label class="form-label">
                  Razão Social: <span class="text-danger">*</span>
                </label>
                <input
                  type="text"
                  class="form-control"
                  :class="{ 'is-invalid': v$.client.socialName.$errors.length }"
                  placeholder="Razão Social da Empresa"
                  v-model="v$.client.socialName.$model"
                />
                <span
                  v-if="v$.client.socialName.required.$invalid"
                  class="invalid-feedback"
                >
                  O campo é obrigatório
                </span>
              </div>
              <div v-if="client.typePerson === '1'" class="col-sm-4">
                <label class="form-label">
                  Nome Fantasia: <span class="text-danger">*</span>
                </label>
                <input
                  type="text"
                  class="form-control"
                  :class="{
                    'is-invalid': v$.client.fantasyName.$errors.length,
                  }"
                  placeholder="Nome Fantasia da Empresa"
                  v-model="v$.client.fantasyName.$model"
                />
                <span
                  v-if="v$.client.fantasyName.required.$invalid"
                  class="invalid-feedback"
                >
                  O campo é obrigatório
                </span>
              </div>
              <div v-if="client.typePerson === '2'" class="col-sm-3">
                <label class="form-label">
                  CPF: <span class="text-danger">*</span>
                </label>
                <input
                  type="text"
                  class="form-control"
                  :class="{ 'is-invalid': v$.client.cnpjcpf.$errors.length }"
                  placeholder="000.000.000-00"
                  v-model="v$.client.cnpjcpf.$model"
                  v-maska="'###.###.###-##'"
                  disabled
                />
                <span
                  v-if="v$.client.cnpjcpf.required.$invalid"
                  class="invalid-feedback"
                >
                  O campo é obrigatório
                </span>
                <span
                  v-if="v$.client.cnpjcpf.minLength.$invalid"
                  class="invalid-feedback"
                >
                  Formato de CPF inválido <br />
                  Ex: 000.000.000-00
                </span>
              </div>
              <div v-if="client.typePerson === '2'" class="col-sm-9">
                <label class="form-label">
                  Nome Completo: <span class="text-danger">*</span>
                </label>
                <input
                  type="text"
                  class="form-control"
                  :class="{
                    'is-invalid': v$.client.socialName.$errors.length,
                  }"
                  placeholder="Nome Completo"
                  v-model="v$.client.socialName.$model"
                />
                <span
                  v-if="v$.client.socialName.required.$invalid"
                  class="invalid-feedback"
                >
                  O campo é obrigatório
                </span>
              </div>
              <div class="col-sm-8">
                <label class="form-label">
                  Endereço: <span class="text-danger">*</span>
                </label>
                <input
                  type="text"
                  class="form-control"
                  :class="{
                    'is-invalid': v$.client.address.$errors.length,
                  }"
                  placeholder="Endereço"
                  v-model="v$.client.address.$model"
                />
                <span
                  v-if="v$.client.address.required.$invalid"
                  class="invalid-feedback"
                >
                  O campo é obrigatório
                </span>
              </div>
              <div class="col-sm-4">
                <label class="form-label">
                  Número: <span class="text-danger">*</span>
                </label>
                <input
                  type="text"
                  class="form-control"
                  :class="{
                    'is-invalid': v$.client.number.$errors.length,
                  }"
                  placeholder="Número"
                  v-model="v$.client.number.$model"
                />
                <span
                  v-if="v$.client.number.required.$invalid"
                  class="invalid-feedback"
                >
                  O campo é obrigatório
                </span>
              </div>
              <div class="col-sm-4">
                <label class="form-label">
                  Bairro: <span class="text-danger">*</span>
                </label>
                <input
                  type="text"
                  class="form-control"
                  :class="{
                    'is-invalid': v$.client.district.$errors.length,
                  }"
                  placeholder="Bairro"
                  v-model="v$.client.district.$model"
                />
                <span
                  v-if="v$.client.district.required.$invalid"
                  class="invalid-feedback"
                >
                  O campo é obrigatório
                </span>
              </div>
              <div class="col-sm-4">
                <label class="form-label">
                  Cidade: <span class="text-danger">*</span>
                </label>
                <input
                  type="text"
                  class="form-control"
                  :class="{
                    'is-invalid': v$.client.city.$errors.length,
                  }"
                  placeholder="Cidade"
                  v-model="v$.client.city.$model"
                />
                <span
                  v-if="v$.client.city.required.$invalid"
                  class="invalid-feedback"
                >
                  O campo é obrigatório
                </span>
              </div>
              <div class="col-sm-4">
                <label class="form-label">
                  Estado: <span class="text-danger">*</span>
                </label>
                <select
                  class="form-select"
                  :class="{
                    'is-invalid': v$.client.stage.$errors.length,
                  }"
                  v-model="v$.client.stage.$model"
                >
                  <option value="">Selecione o Estado</option>
                  <option value="AC">Acre</option>
                  <option value="AL">Alagoas</option>
                  <option value="AP">Amapá</option>
                  <option value="AM">Amazonas</option>
                  <option value="BA">Bahia</option>
                  <option value="CE">Ceará</option>
                  <option value="DF">Distrito Federal</option>
                  <option value="ES">Espírito Santo</option>
                  <option value="GO">Goiás</option>
                  <option value="MA">Maranhão</option>
                  <option value="MT">Mato Grosso</option>
                  <option value="MS">Mato Grosso do Sul</option>
                  <option value="MG">Minas Gerais</option>
                  <option value="PA">Pará</option>
                  <option value="PB">Paraíba</option>
                  <option value="PR">Paraná</option>
                  <option value="PE">Pernambuco</option>
                  <option value="PI">Piauí</option>
                  <option value="RJ">Rio de Janeiro</option>
                  <option value="RN">Rio Grande do Norte</option>
                  <option value="RS">Rio Grande do Sul</option>
                  <option value="RO">Rondônia</option>
                  <option value="RR">Roraima</option>
                  <option value="SC">Santa Catarina</option>
                  <option value="SP">São Paulo</option>
                  <option value="SE">Sergipe</option>
                  <option value="TO">Tocantins</option>
                  <option value="EX">Estrangeiro</option>
                </select>
                <span
                  v-if="v$.client.stage.required.$invalid"
                  class="invalid-feedback"
                >
                  O campo é obrigatório
                </span>
              </div>
              <div class="col-sm-4">
                <label class="form-label">
                  Telefone: <span class="text-danger">*</span>
                </label>
                <input
                  type="text"
                  class="form-control"
                  :class="{
                    'is-invalid': v$.client.phone.$errors.length,
                  }"
                  placeholder="(00) 98888-8888"
                  v-model="v$.client.phone.$model"
                  v-maska="['(##) ####-####', '(##) #####-####']"
                />
                <span
                  v-if="v$.client.phone.required.$invalid"
                  class="invalid-feedback"
                >
                  O campo é obrigatório
                </span>
                <span
                  v-if="v$.client.phone.minLength.$invalid"
                  class="invalid-feedback"
                >
                  Formato de telefone inválido <br />
                  Ex: (00) 98888-8888 / (00) 8888-8888
                </span>
              </div>
              <div class="col-sm-4">
                <label class="form-label">
                  {{
                    client.typePerson === '1'
                      ? 'E-mail do Financeiro'
                      : 'E-mail'
                  }}: <span class="text-danger">*</span>
                </label>
                <input
                  type="email"
                  class="form-control"
                  :class="{
                    'is-invalid': v$.client.email.$errors.length,
                  }"
                  placeholder="usuario@email.com.br"
                  v-model="v$.client.email.$model"
                />
                <span
                  v-if="v$.client.email.required.$invalid"
                  class="invalid-feedback"
                >
                  O campo é obrigatório
                </span>
                <span
                  v-if="v$.client.email.email.$invalid"
                  class="invalid-feedback"
                >
                  Formato de e-mail inválido
                </span>
              </div>
              <div class="col-sm-4">
                <label class="form-label">Código Parceiro</label>
                <input
                  type="text"
                  class="form-control"
                  placeholder="Código Parceiro"
                  v-model="client.partnerCode"
                  disabled
                />
              </div>
            </div>
          </div>
          <div class="modal-footer border-top-0">
            <button
              type="button"
              class="btn btn-link"
              data-bs-dismiss="modal"
              title="Cancelar"
              @click="$emit('closeModal', false)"
            >
              Cancelar
            </button>
            <button
              type="submit"
              class="btn btn-primary"
              title="Atualizar"
              :disabled="v$.$invalid || disableButton"
            >
              <span v-if="disableButton">
                <i class="ph-spinner spinner" />
              </span>
              <span v-else>Atualizar</span>
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import { useVuelidate } from '@vuelidate/core'
import {
  required,
  minLength,
  maxLength,
  email,
  requiredIf,
} from '@vuelidate/validators'
import { maska } from 'maska'
import { showModal, hideModal } from '@/utils/modal'

export default {
  name: 'ClientModal',

  setup() {
    return { v$: useVuelidate() }
  },

  directives: { maska },

  data() {
    return {
      client: {
        cnpjcpf: '',
        socialName: '',
        fantasyName: '',
        address: '',
        number: '',
        district: '',
        city: '',
        stage: '',
        phone: '',
        email: '',
        partnerCode: '',
      },
      disableButton: false,
    }
  },

  methods: {
    async getClient() {
      try {
        this.client = await this.$store.dispatch('getClient')
        showModal('modalClient')
      } catch (error) {
        if (error && error.message) {
          this.$root.$refs.notification.warning(error.message)
        } else {
          this.$root.$refs.notification.error(
            'Não foi possível se conectar ao servidor.',
          )
        }
        this.$emit('closeModal', false)
      }
    },

    async updateClient() {
      if (!this.v$.$invalid) {
        this.disableButton = true
        try {
          const response = await this.$store.dispatch(
            'updateClient',
            this.client,
          )
          if (this.client.typePerson === '2') {
            this.$store.dispatch('setNameUser', this.client.socialName)
          }

          hideModal()
          this.$emit('closeModal', true)
          this.$root.$refs.notification.success(response.message)
        } catch (error) {
          this.disableButton = false
          if (error && error.message) {
            this.$root.$refs.notification.warning(error.message)
          } else {
            this.$root.$refs.notification.error(
              'Não foi possível se conectar ao servidor.',
            )
          }
        }
      }
    },
  },

  validations() {
    return {
      client: {
        cnpjcpf: {
          required,
          minLength: minLength(14),
          maxLength: maxLength(18),
        },
        socialName: {
          required,
        },
        fantasyName: {
          required: requiredIf((client) => {
            if (client.typePerson === '1') {
              return true
            }
            return false
          }),
        },
        address: {
          required,
        },
        number: {
          required,
        },
        district: {
          required,
        },
        city: {
          required,
        },
        stage: {
          required,
        },
        phone: {
          required,
          minLength: minLength(14),
          maxLength: maxLength(15),
        },
        email: {
          required,
          email,
        },
      },
    }
  },

  mounted() {
    this.getClient()
  },
}
</script>
